/** @jsx jsx */
// eslint-disable-next-line
import React from 'react'
import PropTypes from 'prop-types'
import { css, jsx } from '@emotion/core'
import CreateUserForm from './components/CreateUserForm'
import userService from '../../services/user'
import { AnalyticsEventTypes, downloadsAppUrl } from '../../constants'

const styles = {}
styles.container = css`
  width: 100%;
  max-width: 660px;
  margin: auto;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
`

styles.formContainer = css`
  width: 100%;
  margin: auto;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  padding: 32px;

  @media (min-width: 701px) {
    background-image: var(--green-gradient);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border-radius: 8px;
    border-color: var(--metrica-green);
    border-width: 1px;
    border-style: solid;
  }
`

styles.productLogo = css`
  display: block;
  margin: 0 auto 14px auto;
  max-width: 280px;
  width: 55%;
  height: auto;

  @media (max-width: 450px) {
    margin-bottom: 10px;
  }
`

styles.bodyTitle = css`
  color: white;
  text-align: center;
  margin-bottom: 28px;
  font-size: 24px;
  font-weight: 600;
  line-height: 28px;
  padding-right: 5px;
  padding-left: 5px;
  width: 100%;

  @media (max-width: 450px) {
    font-size: 21px;
    line-height: 22px;
    margin-bottom: 20px;
  }
`

styles.firstBodySubtitle = css`
  color: white;
  text-align: center;
  margin-bottom: 2px;
  font-size: 16px;
  padding-right: 5px;
  padding-left: 5px;
  cursor: pointer;
  width: 100%;
`

styles.secondBodySubtitle = css`
  color: white;
  text-align: center;
  margin-bottom: 32px;
  font-size: 16px;
  padding-right: 5px;
  padding-left: 5px;
  cursor: pointer;
  width: 100%;

  @media (max-width: 450px) {
    margin-bottom: 24px;
  }

  @media (max-width: 701px) {
    margin-bottom: 24px;
  }

  & a {
    color: var(--metrica-green);
    text-decoration: underline;
  }
`

function CreateUser(props) {
  const goToDownloads = () => {
    try {
      window.MetricaSportsAnalytics.track(AnalyticsEventTypes.GO_TO_DOWNLOADS)
    } catch (error) {
      console.log('Error logging analytics', error)
    }

    // Existing users go to the product's downloads page (e.g. /nexus) instead of the post-signup
    // one (/from-trial), so they get the desktop app rather than logging in to Cloud.
    const url = new URL(downloadsAppUrl[process.env.REACT_APP_ENV])
    url.pathname = `/${props.product.id}`

    window.open(url.href, '_self')
  }

  return (
    <div css={styles.container}>
      <img css={styles.productLogo} src={props.product.logo} alt={props.product.displayName} />
      <div css={styles.bodyTitle}>
        {window.I18n.t('createUser.title', { product: props.product.displayName })}
      </div>

      {!props.invitationToken && (
        <React.Fragment>
          <div css={styles.firstBodySubtitle}>{window.I18n.t('createUser.signUpHere')}</div>
          <div
            css={styles.secondBodySubtitle}
            onClick={() => {
              goToDownloads()
            }}
            dangerouslySetInnerHTML={{
              __html: window.I18n.t('createUser.alreadyHaveAccount', {
                pre: '<a>',
                post: '</a>'
              })
            }}
          />
        </React.Fragment>
      )}

      <div css={styles.formContainer}>
        <CreateUserForm
          createUserAsync={createUserAsync}
          product={props.product}
          email={props.email}
          language={props.language}
          referral={props.referral}
          token={props.token}
          returnUrl={props.returnUrl}
          invitationToken={props.invitationToken}
          invitationFrom={props.invitationFrom}
          invitationTo={props.invitationTo}
        />
      </div>
    </div>
  )
}

async function createUserAsync(payload) {
  return userService.create(payload)
}

CreateUser.propTypes = {
  product: PropTypes.object.isRequired,
  email: PropTypes.string,
  language: PropTypes.string.isRequired,
  referral: PropTypes.string,
  token: PropTypes.string,
  returnUrl: PropTypes.string,
  invitationToken: PropTypes.string,
  invitationFrom: PropTypes.string,
  invitationTo: PropTypes.string
}

CreateUser.defaultProps = {
  email: undefined,
  referral: undefined,
  token: undefined,
  returnUrl: undefined,
  invitationToken: undefined,
  invitationFrom: undefined,
  invitationTo: undefined
}

export default CreateUser
